import { render, staticRenderFns } from "./FormBroker.vue?vue&type=template&id=383b8502&"
import script from "./FormBroker.vue?vue&type=script&lang=js&"
export * from "./FormBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/transport-app/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports